import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { IconName } from '@shared/components/core/images/IconMap';
import Icons from '@shared/components/core/images/Icons';
import { BodyMedium, LightXSmall } from '@shared/components/core/text/Typography';

export interface IMemberDetailItemProps {
    icon?: IconName;
    iconSize?: number;
    title: string;
    active?: boolean;
    variant?: 'default' | 'small';
    chip?: boolean;
}

export default function MemberDetailItem({
    icon,
    title,
    active = true,
    variant = 'default',
    chip = false,
    iconSize = 24,
}: Readonly<IMemberDetailItemProps>) {
    const BodyComponent = variant === 'default' ? BodyMedium : LightXSmall;

    if (!title) return null;
    return (
        <MemberDetail variant={variant} chip={chip}>
            {icon && <Icons name={icon} size={iconSize} />}
            <BodyComponent>{active ? title : <StrikeThrough aria-hidden>{title}</StrikeThrough>}</BodyComponent>
        </MemberDetail>
    );
}

const StrikeThrough = styled.s`
    text-decoration: line-through;
    color: ${({ theme }) => theme.color.neutral + '90'};
`;
const chipStyle = css`
    margin: 0 10px;
`;

const MemberDetail = styled.div<{ variant: 'default' | 'small'; chip: boolean }>`
    display: flex;
    align-items: center;
    gap: ${({ variant }) => (variant === 'default' ? '0.5rem' : '0.25rem')};
    ${({ chip }) => chip && chipStyle}
`;
